/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_CreateInputs */

const en_tokens_create = /** @type {(inputs: Tokens_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create token`)
};

const de_tokens_create = /** @type {(inputs: Tokens_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token erstellen`)
};

/**
* | output |
* | --- |
* | "Create token" |
*
* @param {Tokens_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_create = /** @type {((inputs?: Tokens_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_create(inputs)
	return en_tokens_create(inputs)
});